import React from "react";
import { useApp } from "@/context/AppContext";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Checkbox } from "@/components/ui/checkbox";
import { Scale } from "lucide-react";

const JURISDICTIONS = ["Any", "Supreme Court of India", "High Court of Andhra Pradesh", "High Court of Telangana", "Delhi High Court", "Bombay High Court", "Other High Court", "Tribunal / Forum"];

// Shared scope controls: jurisdiction, matter grounding, contrary-authority mode.
export function ResearchScope({ scope, onChange, compact = false }) {
  const { db } = useApp();
  const set = (k, v) => onChange({ ...scope, [k]: v });
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="research-scope">
      <Select value={scope.jurisdiction || "Any"} onValueChange={(v) => set("jurisdiction", v)}>
        <SelectTrigger className="h-8 w-[220px] text-xs" data-testid="scope-jurisdiction"><SelectValue placeholder="Jurisdiction" /></SelectTrigger>
        <SelectContent>{JURISDICTIONS.map((j) => <SelectItem key={j} value={j} className="text-xs">{j}</SelectItem>)}</SelectContent>
      </Select>
      <Select value={scope.matterId || "none"} onValueChange={(v) => set("matterId", v === "none" ? null : v)}>
        <SelectTrigger className={compact ? "h-8 w-[200px] text-xs" : "h-8 w-[280px] text-xs"} data-testid="scope-matter"><SelectValue placeholder="Ground in matter" /></SelectTrigger>
        <SelectContent>
          <SelectItem value="none" className="text-xs">Law only — no matter</SelectItem>
          {db.matters.map((m) => <SelectItem key={m.id} value={m.id} className="text-xs">{m.caseNumber} · {m.title}</SelectItem>)}
        </SelectContent>
      </Select>
      <label className="flex items-center gap-1.5 rounded-full border border-line px-2.5 py-1 text-xs text-ink-2" data-testid="scope-contrary">
        <Checkbox checked={!!scope.contrary} onCheckedChange={(v) => set("contrary", !!v)} /> <Scale className="h-3 w-3 text-copper" /> Contrary authority
      </label>
    </div>
  );
}
